
<template lang="pug">
#app
  menu-window
  loading-icon
  material-window
  .menu-button(@click="onClick")
    menu-button
</template>

<script>

import MenuWindow from './MenuWindow'
import MaterialWindow from './MaterialWindow'
import MenuButton from './MenuButton'
import LoadingIcon from './LoadingIcon'
import {mapState, mapMutations} from 'Vuex'


export default {
  props:{},
  components: {
    MenuWindow,
    MaterialWindow,
    MenuButton,
    LoadingIcon
  },
  computed: {
    ...mapState('menu', {isShowMenu: 'isShow'})
  },
  methods: {
    ...mapMutations('menu', {showMenu: 'show', hideMenu: 'hide'}),
    ...mapMutations('material', {hideMaterial: 'hide'}),
    onClick(){
      if(this.isShowMenu){
        this.hideMenu();
      }else{
        this.showMenu();
        this.hideMaterial();
      }
    },
  },
  created () {},
  mounted () {
  },
  data () {
    return {
    }
  },
}
</script>

<style land="stylus">
center-child(){
   display: flex;
   justify-content: center;
   align-items: center;
}
</style>

<style lang="stylus" scoped>
a
  display block
.menu-button
  position fixed
  top 20px
  right 20px
  z-index 200
</style>

